<div class="spinner-wrapper">
    <div class="spinner-backdrop">
        <mat-spinner strokeWidth="5"></mat-spinner>
    </div>
</div>

